export const projectData = [
    {
        id: 'b3ar',
        name: 'Boutique',
        title:'Beauty ecommerce website',
        address: 'https://boutique-nay4.onrender.com/',
        img: '/images/boutique.png',
        summary: "Boutique, I got this inspiration from webflow Ecommerce website called BOUTIQUE, I used Mongodb database to store users data and protect them with bcrypt. Only Admin users can upload, update and delete products in the application or block a user.",
        techStack:['Authenticate users with bcrypt', 'MongoDB database for users and products','ExpressJs and NodeJs for backend','ReactJs for front-end','Bootstrap and tailwind css for styling']
    },
    {
        id: 'c9zk',
        name: 'Tic Tac Toe',
        title:'Classic Javascript Tic Tac Toe Game',
        address: 'https://seyba.github.io/TicTacToe/',
        img: '/images/tictactoe.png',
        summary: "Classic Javascript Tic Tac Toe is a two player game, each player has a turn, the more points a player earn through the crossed board or row is winner. Javascript Object Oriented Programming used to store users points. A player is only allowed to click once at a time on his or her turn in a cell.Once a cell is clicked it cannot be clicked again. A wide screen shows scores when a winning happens. Each player's score is displayed at the end of the game. No score is displayed when there's a tie. players get unlimited time to play by clicking the play button.",
        techStack:["Javascript", "HTML", "CSS", "Component-based UI-kit", "Landing page design"]
    },
    {
        id: 'k7tb',
        name: 'Crypto App',
        title:'Simple Crypto Currencies App',
        address: 'https://comfy-smakager-0be15f.netlify.app/',
        img: '/images/crypto.png',
        summary: "Simple Crypto App generates crypto prices and value from crypto currencies API.",
        techStack:["Javascript", "NodeJS", "ReactJS", "Bootstrap", "Component-based UI-kit"]
    },
    {
        id: 'n3sv',
        name: 'Star Wars',
        title:'Star Wars Starships App',
        address: 'https://ephemeral-dodol-c5b7d0.netlify.app/',
        img: '/images/starwars.png',
        summary: "Starships just fetch data from external API and displays them.",
        techStack: ["Javascript", "NodeJS", "ReactJS", "Bootstrap", "Component-based UI-kit"]
    },
    {
        id: 'l8db',
        name: 'Tweet',
        title:'Tweet App',
        address: 'https://seyba-twitter-app.onrender.com/tweets',
        img: '/images/tweet.png',
        summary: "Simple Full CRUD Twitter App. JSX View engine get data from Mongodb through Nodejs and ExpressJs server.",
        techStack: ["MongoDB", "NodeJS", "JSX View Engine", "ExpressJS", "Web application design", "Tailwind CSS"]
    },
    {
        id: 't9sd',
        name: 'DevShop',
        title:'General Merchandise Ecommerce Site',
        address: 'https://devshop-n1ez.onrender.com/',
        img: '/images/devShop.png',
        summary: "DevShop is a Full-stack Mern ecommerce site. It is bootstrap styled and has a separate admin front-end page. The back-end is running on express and nodejs server. User can browse products, add or remove to his/her cart and proceed to the checkout, however the stripe transaction is not hooked to the site yet. Version 2 will cover that and the responsiveness.",
        techStack: ['ReactJS', 'NodeJS', 'Landing page design', 'Antdesign', 'Marquee','MondoDB', 'Redux', 'Component based UI-kit']
    },
    {
        id: 'l39ds',
        name: 'Redux Contact',
        title:'Redux Contact App',
        address: 'https://redux-contact-app.onrender.com/',
        img: '/images/contactApp.png',
        summary: "Redux Contact App is a regular simple full crud application that takes in user data and store them in redux where the user can manipulate them.",
        techStack: ['ReactJS', 'NodeJS', 'figma mockup', 'Redux', 'Component based UI-kit']
    }

]